// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"28067d98","156":"7eaaee21","237":"d32148a9","249":"d39ebe99","344":"377cf094","359":"e7a1a513","408":"f3608df0","453":"1407b060","465":"9ea416a0","540":"16dcc4d0","555":"7ef587e6","592":"0fa39e4a","626":"c18b3e98","686":"33bf75d4","698":"31ee13a5"}[chunkId] + ".chunk.js";
};